import { httpServices } from '@libs/data-access/queries'

export type CheckRecordsStatusOptions = {
  teamId: string
}

export type CheckRecordsStatusSchema = {
  has_related_shifts: boolean
  has_related_user_contracts: boolean
}

export type UpdateTeamOptions = {
  teamId: number
  payload: {
    shift_templates_attributes: { id: number; index: number }[]
  }
}

export type FetchTeamOptions = {
  teamId?: number
}

export const checkRecordsStatus = async (opts: CheckRecordsStatusOptions) => {
  const response = await httpServices.core.get<CheckRecordsStatusSchema>(
    `/teams/${opts.teamId}/related_records_status`
  )
  return response.data
}

export const updateTeam = async (opts: UpdateTeamOptions) => {
  const response = await httpServices.core.put(
    `/teams/${opts.teamId}`,
    opts?.payload
  )
  return response.data
}

export const fetchTeam = async (opts: FetchTeamOptions) => {
  const response = await httpServices.core.get(`/teams/${opts.teamId}`)
  return response.data
}
